module.exports = __webpack_public_path__ + "img/img.c648e392.png";